module.exports = __webpack_public_path__ + "img/12-12.2d30ccae.png";